import React, { useCallback, useState, createContext, useContext } from 'react';
interface CartContextType {
  bump1: boolean;
  bump2: boolean;
  setBump1: (v: boolean) => void;
  setBump2: (v: boolean) => void;
  totalPrice: number;
  getCartUrl: () => string;
}
const CartContext = createContext<CartContextType | null>(null);
export function CartProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const totalPrice = 14 + (bump1 ? 9 : 0) + (bump2 ? 9 : 0);
  const getCartUrl = useCallback(() => {
    if (bump1 && bump2) return 'https://coresolutionsg.com/cart/47554402091195:1';
    if (bump1) return 'https://coresolutionsg.com/cart/47554396455099:1';
    if (bump2) return 'https://coresolutionsg.com/cart/47554400649403:1';
    return 'https://coresolutionsg.com/cart/47486850629819:1';
  }, [bump1, bump2]);
  return <CartContext.Provider value={{
    bump1,
    bump2,
    setBump1,
    setBump2,
    totalPrice,
    getCartUrl
  }} data-id="element-17">
      {children}
    </CartContext.Provider>;
}
export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used within CartProvider');
  return ctx;
}